<template>
  <el-form class="kewen-sentence-form" ref="form" label-width="100px">
    <el-form-item label="分组">
      <el-input v-model="paragraph" style="width:194px;"></el-input>
    </el-form-item>
    <el-form-item label="角色">
      <el-select filterable v-model="rid">
        <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="时间">
      <TimeRangeInput class="kw-timeline" v-model="time_range" :asarray="false"></TimeRangeInput>
    </el-form-item>
    <el-form-item label="句子" @change.native.capture="handleVMDialogText('text', 'pinyin')">
      <el-input v-model="text"></el-input>
      <PinyinPreview class="pinyin-preview" :text="text" :pinyin="pinyin" popover></PinyinPreview>
      <div style="color:#E6A23C;line-height:1.3;margin-top:3px;">注意：修改句子后请检查自动出题配置，如果有用到也需要一并修改</div>
    </el-form-item>
    <el-form-item label="拼音" @change.native.capture="handleVMDialogText('text', 'pinyin')">
      <PinyinInput v-model="pinyin" :text="text"></PinyinInput>
    </el-form-item>
    <el-form-item label="驰声语音">
      <el-input v-model="text_chivox"></el-input>
    </el-form-item>
    <el-form-item label="音频">
      <FileInput v-model="audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="显示位置" style="margin-bottom:12px;">
      <el-input v-model="weight"></el-input>
    </el-form-item>
    <el-collapse>
      <el-collapse-item name="自动出题配置">
        <template #title>
          <div class="text-center flex1">自动出题配置</div>
        </template>
        <BuildExerciseConfig v-model="data.exercise_config" :words="text"></BuildExerciseConfig>
      </el-collapse-item>
    </el-collapse>
    <div class="text-right mt15">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-form>
</template>

<script>
import dialog from '@/components/mixins/dialog.js'
import BuildExerciseConfig from "@/views/sentence/BuildExerciseConfig.vue";
import {getDataJson} from "@/views/sentence/util.js";

export default {
  name: 'KewenSentenceForm',
  components: {
    PinyinPreview: require('@/components/PinyinPreview').default,
    PinyinInput: require('@/components/PinyinInput').default,
    TimeRangeInput: require('@/components/TimeRangeInput').default,
    FileInput: require('@/components/FileInput').default,
    BuildExerciseConfig
  },
  mixins: [dialog],
  props: {
    roles: Array,
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      id: null,
      kid: null,
      pid: null,
      rid: null,
      sid: null,
      text: '',
      pinyin: '',
      audio: '',
      weight: 0,
      paragraph: '',
      time_range: '',
      text_chivox: '',
      data: {},
      key: null,
    }
  },
  watch: {
    value () {
      this.initData(this.value)
    }
  },
  mounted () {
    this.initData(this.value)
  },
  methods: {
    initData (item) {
      this.id = item.id || null;
      this.kid = item.kid || null;
      this.pid = item.pid || null;
      this.rid = item.rid || null;
      this.sid = item.sid || null;
      this.text = item.text || ''
      this.pinyin = item.pinyin || ''
      this.audio = item.audio || ''
      this.paragraph = item.paragraph || ''
      this.time_range = item.time_range || ''
      this.text_chivox = item.text_chivox || ''
      this.weight = item.weight || 0;
      this.data = item.data || (item.data_json ? JSON.parse(item.data_json) : {});
      this.key = item.key;
    },
    cancel () {
      this.$emit('cancel')
    },
    submit () {
      const data = {
        id: this.id,
        kid: this.kid,
        pid: this.pid,
        rid: this.rid,
        sid: this.sid,
        text: this.text,
        pinyin: this.pinyin,
        audio: this.audio,
        weight: this.weight,
        paragraph: this.paragraph,
        time_range: this.time_range,
        text_chivox: this.text_chivox,
        data_json: getDataJson(this.data),
        key: this.key,
      };
      this.$emit('input', data);
      this.$emit('change', data);
    }
  }
}
</script>
